
import { defineComponent } from "vue";
import Modal from "../Components/Modal.vue";
import { ActionTypes } from "../../stores/action-types";
import { LoggedInPlayer } from "../../protocol/dto/logged-in-player";
import { useStore } from "../../stores";
import AppConfig from "../../config/app-config";

export default defineComponent({
  name: "login",
  
  data() {
    return {
      errorMessage: "",
      input: {
        username: "",
        password: "",
      },
    };
  },

  methods: {
    login(): void {
      const store = useStore();
      if (this.input.username != '' && this.input.password != '') {
        const user: LoggedInPlayer = {
          username: this.input.username,
          password: this.input.password,
        };
        
        const res = store.dispatch(ActionTypes.USER_LOGIN, user); // login the user

        res.catch(error => {
          if (!error) {
            this.errorMessage = 'Incorrect username or password. Please try again';
          }
        });

      } else {
        this.errorMessage = 'Please enter a username and password';
      }
    },

    guestLogin(): void {
      const store = useStore();
      const user: LoggedInPlayer = {
        username: '',
        password: '',
      };
      store.dispatch(ActionTypes.USER_LOGIN, user); // login as guest
    },

    close(): void {
      window.location.href = AppConfig.WEB_SITE_HOME_PAGE;
    },

    clearErrorMessage(): void {
      this.errorMessage = '';
    },
  },

  components: { Modal },
});
